<div class="main-content table-page table-page--compact cliente-incidencias-page incidencias-board-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Mis incidencias</h1>
        <p>Seguimiento operativo de incidentes reportados para sus aplicaciones y servicios.</p>
      </div>

      <button
        type="button"
        mat-raised-button
        class="btn table-page__primary-btn"
        [disabled]="!selectProyecto || !selectEtapa"
        (click)="nuevaIncidencia()">
        <span class="material-icons">add</span>
        Nueva incidencia
      </button>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid incidencias-board-page__filters-grid">
          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Proyecto</mat-label>
              <mat-select [(ngModel)]="selectProyecto" (selectionChange)="capturarProyecto($event.value)">
                <mat-option *ngFor="let proyecto of proyectos" [value]="proyecto.id">
                  {{ proyecto.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--medium" *ngIf="etapas.length > 0">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Etapa</mat-label>
              <mat-select [(ngModel)]="selectEtapa" (selectionChange)="capturarEtapa($event.value)">
                <mat-option *ngFor="let etapa of etapas" [value]="etapa.idEtapa || etapa.id">
                  {{ etapa.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="incidencias-board-page__toolbar-summary">
          <span>Total</span>
          <strong>{{ totalIncidencias }}</strong>
        </div>
      </div>

      <div class="cliente-incidencias-page__summary">
        <article class="cliente-incidencias-page__metric" *ngFor="let columna of columnas">
          <span class="material-icons" [ngStyle]="{ color: columna.color }">{{ columna.icon }}</span>
          <div>
            <strong>{{ getTotal(columna.titulo) }}</strong>
            <small>{{ columna.titulo }}</small>
          </div>
        </article>
      </div>

      <ng-container *ngIf="selectProyecto && selectEtapa; else seleccionPendienteTpl">
        <div class="cliente-incidencias-page__latest" *ngIf="ultimasIncidencias.length > 0">
          <h2>Últimas incidencias</h2>
          <div class="table-page__table-wrap">
            <table class="table-page__table">
              <thead>
                <tr>
                  <th>Folio</th>
                  <th>Título</th>
                  <th>Estatus</th>
                  <th>Prioridad</th>
                  <th>Fecha</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let incidencia of ultimasIncidencias">
                  <td>#{{ incidencia.id_incidencia_proyecto || incidencia.id }}</td>
                  <td>
                    <span class="table-page__name">{{ incidencia.titulo }}</span>
                    <span class="table-page__subtext">{{ incidencia.descincidencia }}</span>
                  </td>
                  <td><span class="table-page__status-badge">{{ incidencia.estatus }}</span></td>
                  <td>{{ incidencia.prioridad }}</td>
                  <td>{{ incidencia.fecha_creacion }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="incidencias-board-page__board-shell">
          <div class="incidencias-board-page__board" [class.is-loading]="loading">
            <article
              class="incidencias-board-page__column"
              *ngFor="let columna of columnas"
              [style.--incidencia-column-color]="columna.color">
              <header class="incidencias-board-page__column-header" [style.backgroundColor]="columna.color">
                <div class="incidencias-board-page__column-title">
                  <span class="material-icons">{{ columna.icon }}</span>
                  <div class="incidencias-board-page__column-title-text">
                    <strong>{{ columna.titulo }}</strong>
                    <small>{{ getTotal(columna.titulo) }}</small>
                  </div>
                </div>
              </header>

              <div class="incidencias-board-page__column-body">
                <ng-container *ngIf="getLista(columna.titulo).length > 0; else emptyColumnTpl">
                  <article class="incidencias-board-card" *ngFor="let incidencia of getLista(columna.titulo)">
                    <header class="incidencias-board-card__header">
                      <span class="incidencias-board-card__ticket" [ngStyle]="{ 'background-color': columna.color }">
                        {{ incidencia.id_incidencia_proyecto || incidencia.id }}
                      </span>
                      <div class="incidencias-board-card__title-block">
                        <strong matTooltip="{{ incidencia.titulo }}">
                          {{ incidencia.titulo.length > 28 ? (incidencia.titulo | slice : 0 : 28) + '…' : incidencia.titulo }}
                        </strong>
                        <span class="incidencias-board-card__date">
                          <span class="material-icons">date_range</span>
                          {{ incidencia.fecha_creacion }}
                        </span>
                      </div>
                    </header>

                    <div class="incidencias-board-card__badges">
                      <span class="incidencias-board-card__badge">{{ incidencia.prioridad }}</span>
                      <span class="incidencias-board-card__badge">{{ incidencia.tipo }}</span>
                    </div>

                    <p class="incidencias-board-card__description" matTooltip="{{ incidencia.descincidencia }}">
                      {{ incidencia.descincidencia.length > 72 ? (incidencia.descincidencia | slice : 0 : 72) + '…' : incidencia.descincidencia }}
                    </p>
                  </article>
                </ng-container>

                <ng-template #emptyColumnTpl>
                  <div class="table-page__empty-state incidencias-board-page__empty-column">
                    <span class="material-icons">inbox</span>
                    <p>Sin incidencias en este estatus.</p>
                  </div>
                </ng-template>
              </div>
            </article>
          </div>
        </div>
      </ng-container>

      <ng-template #seleccionPendienteTpl>
        <div class="table-page__empty-state incidencias-board-page__empty-selection">
          <span class="material-icons">dashboard_customize</span>
          <p>Seleccione un proyecto y una etapa para ver sus incidencias.</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>
